import { LANDING_ROUTES, TERMS_SLUGS, TermsSlugType } from '@cyberkongz/ui';
import { TermsLayout } from '@features/terms/TermsLayout';
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import { ParsedUrlQuery } from 'querystring';
import React from 'react';

export default function TermsPage({ termsType }: InferGetStaticPropsType<typeof getStaticProps>) {
  return <TermsLayout terms={termsType} />;
}

export async function getStaticProps({ params }: GetStaticPropsContext) {
  const termsType = (params as ParsedUrlQuery).termsType as string;
  const isValidTermsType = TERMS_SLUGS.some((term) => term === termsType);

  return {
    notFound: !isValidTermsType,
    props: {
      termsType: termsType as TermsSlugType,
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: TERMS_SLUGS.map((termsType) => LANDING_ROUTES.TERMS(termsType)),
    fallback: 'blocking',
  };
}
